<template>
  <div>
    <div v-if="!intents || intents.length === 0" class="text-medium-emphasis text-body-2 py-2">{{ emptyText }}</div>
    <v-list v-else density="compact" class="py-0 usage-list">
      <v-list-item v-for="(intent, index) in intents" :key="rowKey(intent, index)" class="px-0">
        <v-list-item-title class="text-body-2 usage-path">{{ pathText(intent) }}</v-list-item-title>
        <v-list-item-subtitle class="text-caption mt-1">
          <v-chip size="x-small" label variant="tonal" class="mr-1">{{ intent.rawLevel || '-' }}</v-chip>
          <span class="mr-1">{{ $t('accessLevelLadderEffective') }}</span>
          <v-chip size="x-small" label variant="tonal" color="primary" class="mr-2">{{ intent.effectiveLevel || '-' }}</v-chip>
          <span>{{ intent.nodeType }}</span>
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
/**
 * รายการ intent ที่ตั้ง Access Level (`AccessLevelIntentUsageDto[]` จาก `GET api/v1/AccessLevel/usage`
 * หรือ `data.intents` ของ 409 ตอนลบระดับ) — แสดง flow › router › เส้นทาง intent + ระดับที่ตั้ง/ระดับจริงตามเส้นทาง
 */
export default {
  name: 'AccessLevelUsageList',
  props: {
    intents: { type: Array, default: () => [] },
    emptyText: { type: String, default: '' },
  },
  methods: {
    pathText(intent) {
      const path = Array.isArray(intent && intent.intentPath) ? intent.intentPath : [intent && intent.intentName];
      return [intent && intent.flowName, intent && intent.routerName, ...path]
        .filter((part) => part != null && String(part).trim() !== '')
        .join(' › ');
    },
    rowKey(intent, index) {
      return `${(intent && intent.nodeId) || ''}:${(intent && intent.intentId) || ''}:${index}`;
    },
  },
};
</script>

<style scoped>
.usage-path {
  white-space: normal;
}

.usage-list :deep(.v-list-item) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
